import React from 'react';
import clsx from 'clsx';

import styles from './Chat.module.css';
import { ChatWindow } from './ChatWindow';
import { AnimatedButton } from 'components/Map/AnimatedButton';

interface ChatWidgetProps {
  digitalMapId: string;
}

export const ChatWidget: React.FC<ChatWidgetProps> = ({ digitalMapId }) => {
  const [open, setOpen] = React.useState<boolean>(false);
  const chatInputRef = React.useRef<HTMLTextAreaElement>(null);

  const toggleOpen = (): void => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
      setTimeout(() => {
        if (chatInputRef.current) {
          chatInputRef.current.focus();
        }
      }, 100);
    }
  };

  return (
    <>
      <AnimatedButton
        className={styles.chatButton}
        clickedClassName={styles.clicked}
        onClick={toggleOpen}
      >
        <img src="/static/images/map/nutmeg-ai-logo.svg" className={styles.chatIcon} alt="chat" />
      </AnimatedButton>
      <div className={clsx(styles.overlay, open && styles.open)}>
        <ChatWindow
          digitalMapId={digitalMapId}
          onClose={() => setOpen(false)}
          className={clsx(open && styles.open, styles.chatWidgetWindow)}
        />
      </div>
    </>
  );
};
